import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=0b13b7d2&scoped=true&"
import script from "./TransactionsView.vue?vue&type=script&setup=true&lang=js&"
export * from "./TransactionsView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13b7d2",
  null
  
)

export default component.exports